import { graphql, useStaticQuery } from "gatsby"
import { TSponsor } from "../types"

const footer = (): TSponsor[] => {
  const query = useStaticQuery(
    graphql`
      query {
        allSponsor {
          nodes {
            id
            title
            link
            logo {
              id
              title
              ... on DatoCmsAsset {
                gatsbyImageData(
                  imgixParams: {h: "100"}
                )
              }
            }
            backgroundImage {
              id
              title
              ... on DatoCmsAsset {
                gatsbyImageData(
                  imgixParams: {h: "100"}
                )
              }
            }
            ... on DatoCmsSponsor {
              id
              sponsorCategories {
                categoryName
                slug
              }
            }
          }
        }
      }
    `
  )
  return query.allSponsor.nodes
}

export default footer
